import styles from './MainNavigation.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import MobileMenu from './MobileMenu';

export default function MainNavigation() {
    const location = useLocation();
    const navigate = useNavigate();

    const handleNavClick = (event, section) => {
        event.preventDefault(); 
    
        if (location.pathname !== "/") {
          navigate("/"); 
          setTimeout(() => {
            document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
          }, 100); 
        } else {
          document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
        }
      };

    return (
        <header className={styles.headerNav}>
            <section className={styles.schoolName}>
                <img src='/icons/kpjadhavlogo.webp' alt='kpjadhav logo' />
                <p>K. P. Jadhav Highschool & Junior College</p>
            </section>
            <nav className={styles.Nav}>
                    <a href='#home' onClick={(e) => handleNavClick(e, "home")}>Home</a>
                    
                    <a href='#about-us' onClick={(e) => handleNavClick(e, "about-us")}>About</a>
                   
                    <a href='#gallery' onClick={(e) => handleNavClick(e, "gallery")}>Gallery</a>
                  
                    <a href='#trustees-info' onClick={(e) => handleNavClick(e, "trustees-info")} >Trustees</a>
                    
                    <a href='#academics' onClick={(e) => handleNavClick(e, "academics")}>Academics</a>
                   
                    <a href='#admission'  onClick={(e) => handleNavClick(e, "admission")}>Admission</a>
                   
                    <a href='#footer' onClick={(e) => handleNavClick(e, "footer")}>Contact</a>
            </nav>
            <MobileMenu handleNavClick={handleNavClick}/>
        </header>
    
    )
}

